/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".badge[_ngcontent-%COMP%]{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;position:relative;font-size:.9em;padding:2px 8px}.background[_ngcontent-%COMP%]{position:absolute;top:0;left:0;right:0;bottom:0;opacity:.2;border-radius:3px}.badge.is-outline[_ngcontent-%COMP%]   .background[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
